<template>
    <div class="content-wrapper" style="height: 100% !important;">
        <div class="main-content">
           <sign-in />
        </div>
    </div>
</template>

<script>
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
import SignIn from '@/components/UserLogin/SignIn.vue';
export default {
    components: {
        SignIn,
    },
    computed: {
        ...mapGetters(["currentLanguage"]),
    },
    methods: {
        updateHeadMeta() {
            const title =
                this.currentLanguage === "ar"
                    ? "تسجيل الدخول - Planning Force | الوصول إلى حسابك"
                    : "Login - Planning Force | Access Your Account";

            const description =
                this.currentLanguage === "ar"
                    ? "قم بتسجيل الدخول للوصول إلى حسابك في Planning Force وابدأ في إدارة دوراتك التدريبية."
                    : "Log in to access your account on Planning Force and start managing your training courses.";

            const keywords =
                this.currentLanguage === "ar"
                    ? "تسجيل الدخول, حساب المستخدم, إدارة الدورات, تعلم إلكتروني, Planning Force"
                    : "login, user account, course management, e-learning, Planning Force";

            useHead({
                title: title,
                meta: [
                    { name: "description", content: description },
                    { name: "keywords", content: keywords },
                    { name: "robots", content: "index, follow" },
                    {
                        name: "author",
                        content:
                            this.currentLanguage === "ar"
                                ? "معهد Planning Force العالي للتدريب"
                                : "Planning Force High Institute for Training",
                    },
                    {
                        name: "language",
                        content: this.currentLanguage === "ar" ? "ar" : "en",
                    },

                    // Open Graph meta tags
                    { property: "og:title", content: title },
                    { property: "og:description", content: description },
                    {
                        property: "og:image",
                        content: "https://example.com/login-og-image.jpg", // Replace with your login page image URL
                    },
                    { property: "og:url", content: "https://example.com/login" }, // Replace with your login page URL
                    { property: "og:type", content: "website" },

                    // Twitter Card meta tags
                    { name: "twitter:card", content: "summary_large_image" },
                    { name: "twitter:title", content: title },
                    { name: "twitter:description", content: description },
                    {
                        name: "twitter:image",
                        content: "https://example.com/login-twitter-image.jpg", // Replace with your login page image URL
                    },
                ],
            });
        }

    },
    mounted() {
        this.updateHeadMeta();
    },
    watch: {
        currentLanguage: {
            handler(newLang, oldLang) {
                //  this.language = newLang;
                this.updateHeadMeta();
            },
            immediate: true, // Run the handler immediately when the component is mounted
        },
    },
};
</script>